<template>
    <SimpleModal
        v-if="showModal"
        :show-close-button="false"
        @close="$emit('close')"
    >
        <template v-slot:header>
            <h2>
                Negotiator Settings<br>
                <small>{{ agent.fullname }}</small>
            </h2>
        </template>
        <template v-slot:body>
            <div class="form-group">
                <label>
                    <input
                        type="checkbox"
                        name="hide_tenant_details_on_enquiry"
                        v-model="formData.hide_tenant_details_on_enquiry"
                    />
                    Tenant details hidden on enquiry emails
                </label>
                <div class="form-error">{{ errors.first('hide_tenant_details_on_enquiry') }}</div>
            </div>
        </template>
        <template v-slot:footer>
            <div class="d-flex justify-content-between">
                <button
                    type="button"
                    class="btn btn--transparent-outlined"
                    :disabled="isLoading"
                    @click.prevent="onCancel"
                >
                    Cancel
                </button>
                <button
                    type="button"
                    class="btn btn--secondary"
                    :disabled="isLoading"
                    @click.prevent="onSave"
                >
                    Save
                </button>
            </div>
        </template>
    </SimpleModal>
</template>

<script>
import SimpleModal from '@components/partials/modal/SimpleModal.vue';
import { mapActions } from 'vuex';

export default {
    $_veeValidate: {
        validator: 'new', // give me my own validator scope.
    },
    components: {
        SimpleModal,
    },
    props: {
        showModal: {
            type: Boolean,
            required: true,
        },
        agent: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            formData: {
                hide_tenant_details_on_enquiry: false,
            },
            isLoading: false,
        };
    },
    watch: {
        showModal(isOpened) {
            if (!isOpened) {
                this.formData = {
                    hide_tenant_details_on_enquiry: false,
                };
            } else {
                this.formData = {
                    hide_tenant_details_on_enquiry: this.agent.hide_tenant_details_on_enquiry,
                };
            }
            this.$validator.reset();
        },
    },
    methods: {
        ...mapActions('user', ['updateAgentSettings']),
        onSave() {
            this.$validator.validate().then(async (valid) => {
                if (valid) {
                    this.isLoading = true;
                    await this.updateAgentSettings({ uuid: this.agent.uuid, ...this.formData });
                    this.isLoading = false;
                    window.showToastSuccess('Settings saved.');
                    this.$emit('close');
                }
            });
        },
        onCancel() {
            this.$emit('close');
        },
    },
};
</script>
